export default __webpack_public_path__ + "images/heart.v-da46ab6be57d60ac7b0894e55cfdaf6c.svg";